import React, {Component, useRef} from "react";
import DropdownTreeSelect from "react-dropdown-tree-select";
import {BiX} from "react-icons/bi";
import MSTreeSelectedCtrl from "./MSTreeSelectedCtrl";


class MultiselectTreeCtrl extends Component {

    constructor(props) {
        super(props);
        this.selectedItemsCompRef = React.createRef();
        // Don't call this.setState() here!
        this.state = { options: [], selectedItems: [] };

        // --- ASSIGNING DATA FROM PARENT COMPONENT TO CURRENT STATE
        if(Array.isArray(this.props.options)) {
            if(this.props.refId == 'access-group'){
                this.state.options = refineOption(this.props.options);
            }else{
                this.state.options = this.props.options;
            }

        }

        this.onSelectedItemsRemoved = (remainingSelectedItems) => {
            const updatedOption = checkItemsFromOptions(this.state.options, remainingSelectedItems);
            this.setState({options: updatedOption});
            // MAKING SURE THE UPDATED ITEMS ARE TRIGGERED TO PARENT COMPONENT
            this.props.outSelectedItem(remainingSelectedItems);
        }
    }

    componentDidMount() {
        // SECTION FOR LOADING NETWORK REQUEST
       // console.log('MSTreeCtrl-componentDidMount', this.selectedItemsCompRef )

        if(this.selectedItemsCompRef && Array.isArray(this.state.selectedItems) && this.state.selectedItems.length){
          //  console.log('MSTreeCtrl-componentDidUpdate', this.props.refId +' - ', this.state.selectedItems)
            this.selectedItemsCompRef.current.setSelectedNodes(this.state.selectedItems);
        }

    }

    shouldComponentUpdate(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): boolean {
        this.state.selectedItems = getSelectedItems(this.state.options);
        return true;
    }

    getSnapshotBeforeUpdate(prevProps: Readonly<P>, prevState: Readonly<S>): SS | null {
        return null;
    }

    render() {
        //console.log('MSTreeCtrl-render', this.props.refId +' - ', this.state.options)
        this.state.selectedItems  = getSelectedItems(this.state.options);
        this.onTreeSelectChanged = (x,selectedNodes) => {
            // MAKING SURE THE UPDATED ITEMS ARE TRIGGERED TO PARENT COMPONENT
            this.selectedItemsCompRef.current.setSelectedNodes(selectedNodes);
            this.props.outSelectedItem(selectedNodes);
        }
        return (
            <div className={'custom-dts-container'}>
                <MSTreeSelectedCtrl labelKey={this.props.labelKey} ref={this.selectedItemsCompRef } selectedItemsRemoved={this.onSelectedItemsRemoved}></MSTreeSelectedCtrl>
                <DropdownTreeSelect
                    data={this.state.options}
                    onChange={(selectedNode,selectedNodes) => this.onTreeSelectChanged(selectedNode, selectedNodes)}
                    showPartiallySelected={true}
                    className="custom-dts"
                />
            </div>

        );
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        // SECTION FOR  NETWORK REQUEST BASED ON SOME ATTRIBUTES / PROPS / STATE VALUES
         // console.log('MSTreeCtrl-componentDidUpdate', this.props.refId )

        if(this.selectedItemsCompRef && Array.isArray(this.state.selectedItems) && this.state.selectedItems.length){
            // console.log('MSTreeCtrl-componentDidUpdate', this.props.refId +' - ', this.state.selectedItems)
            this.selectedItemsCompRef.current.setSelectedNodes(this.state.selectedItems);
        }

    }

    componentWillUnmount() {
         //console.log('MSTreeCtrl-componentWillUnmount', this.props.refId )
        // console.log('-------------------');
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
         //console.log('MSTreeCtrl-componentDidCatch', this.props.refId )
    }

}

export default MultiselectTreeCtrl;


/* HELPER FUNCTIONS STARTS HERE */
// ------------------------------
export const getSelectedItems = (data: any) => {
    const selectedItems: any = [];
    if(Array.isArray(data) && data.length){
        data.forEach(item => {
            if(item.checked){
                selectedItems.push(item);
            }

            if(Array.isArray(item.children)){
                const selectedChildren = getSelectedItems(item.children)
                Array.prototype.push.apply(selectedItems,selectedChildren)
            }
        })
    }
    return selectedItems
};
export const uncheckItemsFromOptions = (data: any, uncheckedItem?: any) => {
    if(Array.isArray(data) && data.length){
        data.forEach(item => {
            if(!uncheckedItem){
                item.checked = false;
                uncheckItemsFromOptions(item.children)
            }else{
                if(item.value == uncheckedItem.value){
                    item.checked = false;
                }
                if(Array.isArray(item.children)){
                    uncheckItemsFromOptions(item.children, uncheckedItem)
                }
            }

        })
    }
    return data;
};

export const checkItemsFromOptions = (data: any, checkedItems: any) => {
    if(Array.isArray(data) && data.length){
        data.forEach(item => {
            item.checked = false;
            if(Array.isArray(checkedItems)){
                checkedItems.forEach(childItem => {
                    if(item.value == childItem.value){
                        item.checked = true;
                    }
                })
                checkItemsFromOptions(item.children, checkedItems)
            }

        })
    }
    return data;
};

export const refineOption = (data: any) => {
    if(Array.isArray(data) && data.length){
        data.forEach(item => {
            item.checked = false;
            if(item.checked == null || item.checked == false){
                delete item.checked;
            }
            if(Array.isArray(item.children)){
                item.children = refineOption(item.children);
            }
        })
    }
    return data;
};




